import experience$1 from './v2/index.js';
import experience$2 from './v3/index.js';
import experience$3 from './v4/index.js';
import './v2/learnActions.js';
import './v3/thinkAnalytics.js';
import '@dtvgo/constants';
import '@dtvgo/typed-normalizr';
import '../utils/normalizr/constants.js';
import '../utils/normalizr/entities.js';
import 'query-string';
import '../utils/normalizr/interfaces.js';
import '../utils/normalizr/utils.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import './v3/playback.js';
import './v4/playback.js';

var experience = {
  v2: experience$1,
  v3: experience$2,
  v4: experience$3
};

export { experience as default };
//# sourceMappingURL=index.js.map
